import { UpsellCardBaseProps, UpsellCardHeaderProps } from '../models/upsell-card-props';
import { ActionButton, DismissButton } from './UpsellCardButtons';
import styles from './UpsellCardHeader.module.css';

export const UpsellCardHeader: React.FC<UpsellCardBaseProps & UpsellCardHeaderProps> = (props) => {
    const { title, description, action, dismiss, background } = props;

    return (
        <s-section padding="none">
            <div className="flex h-full flex-col md:card-fix-height justify-between hover-reveal-group">
                <div
                    className={`flex items-center justify-between px-4 py-2 ${styles.header}`}
                    style={background ? { background } : undefined}
                >
                    <div className="flex items-center gap-2 font-semibold">
                        {props.header.icon && <s-icon type={props.header.icon}></s-icon>}
                        <div className="text-body-md font-semibold">{props.header.text}</div>
                    </div>
                    {dismiss && <DismissButton dismiss={dismiss} />}
                </div>
                <div
                    className={`flex flex-1 flex-col justify-between px-4 py-5 ${styles.headerBody}`}
                    style={props.bodyBackground ? { background: props.bodyBackground } : undefined}
                >
                    <div className="text-heading-lg font-bold mt-1">{title}</div>
                    <div className="text-body-md mt-1 mb-4">{description}</div>
                    {action && (
                        <div className="mt-auto pt-2">
                            <ActionButton action={action} fill />
                        </div>
                    )}
                </div>
            </div>
        </s-section>
    );
};
